import * as DISTRICT_TYPES from './actionTypes';
import {
  IFetchDistrictListRequest,
  IFetchDistrictListSuccess,
  IFetchDistrictListFailure,
  IFetchDistrictListSuccessPayload,
  IClearDistrictList
} from './types';

export const fetchDistrictListRequest = ({
  divisionId,
  successCb,
  failureCb
}: Omit<IFetchDistrictListRequest, 'type'>): IFetchDistrictListRequest => ({
  type: DISTRICT_TYPES.FETCH_DISTRICT_LIST_REQUEST,
  divisionId,
  successCb,
  failureCb
});

export const fetchDistrictListSuccess = (payload: IFetchDistrictListSuccessPayload): IFetchDistrictListSuccess => ({
  type: DISTRICT_TYPES.FETCH_DISTRICT_LIST_SUCCESS,
  payload
});

export const fetchDistrictListFailure = (error: Error): IFetchDistrictListFailure => ({
  type: DISTRICT_TYPES.FETCH_DISTRICT_LIST_FAILURE,
  error
});

export const clearDistrictList = (): IClearDistrictList => ({
  type: DISTRICT_TYPES.CLEAR_DISTRICT_LIST
});
